import { render, staticRenderFns } from "./ListCreditNote.vue?vue&type=template&id=220f4548&scoped=true&"
import script from "./ListCreditNote.vue?vue&type=script&lang=js&"
export * from "./ListCreditNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220f4548",
  null
  
)

export default component.exports